/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in es. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('es', {
	fields: {
		allowDuplicates: 'Permitir cartas duplicadas',
		allowReversals: 'Permitir cartas invertidas',
		antardasha: 'Antardasha',
		approximateDate: 'Fecha aproximada',
		arcana: 'Arcano',
		aspectTypes: 'Tipos de aspecto',
		avasthaInfo: 'Incluir detalles de avastha',
		ayanamsa: 'Ayanamsa',
		ayanamsaValue: 'Valor de ayanamsa personalizado',
		biorhythm: 'Biorritmo',
		birthData: 'Datos de nacimiento',
		birthDate: 'Fecha de nacimiento',
		birthLatitude: 'Latitud de nacimiento',
		birthLongitude: 'Longitud de nacimiento',
		birthTime: 'Hora de nacimiento',
		chakra: 'Chakra',
		color: 'Color',
		context: 'Dónde lo viste',
		coordinateSystem: 'Sistema de coordenadas',
		count: 'Cantidad',
		currentYear: 'Año',
		date: 'Fecha',
		datetime: 'Fecha y hora',
		day: 'Día',
		division: 'Carta divisional',
		domainWeights: 'Ponderación de dominios',
		domains: 'Dominios',
		element: 'Elemento',
		endDate: 'Fecha de fin',
		endDatetime: 'Fecha y hora de fin',
		expression: 'Número de expresión',
		family: 'Familia de yoga',
		focus: 'Enfoque',
		fullName: 'Nombre completo',
		horaryNumber: 'Número horario',
		houseSystem: 'Sistema de casas',
		id: 'ID',
		include: 'Cuerpos adicionales',
		interpretation: 'Significado de la posición',
		intervalMinutes: 'Intervalo en minutos',
		iso2: 'Código de país',
		lang: 'Idioma',
		latitude: 'Latitud',
		letter: 'Letra inicial',
		lifePath: 'Número del camino de vida',
		limit: 'Resultados por página',
		lines: 'Patrón de líneas',
		longitude: 'Longitud',
		mahadasha: 'Mahadasha',
		members: 'Miembros del grupo',
		minSignificance: 'Importancia mínima',
		minStrength: 'Fuerza mínima',
		modernPlanets: 'Incluir planetas modernos',
		month: 'Mes',
		name: 'Nombre',
		natalChart: 'Carta natal',
		nodeType: 'Tipo de nodo lunar',
		number: 'Número',
		offset: 'Resultados a omitir',
		orb: 'Orbe',
		person1: 'Persona 1',
		person2: 'Persona 2',
		personA: 'Persona A',
		personB: 'Persona B',
		planet: 'Planeta',
		planets: 'Planetas',
		positions: 'Posiciones de la tirada',
		pratyantardasha: 'Pratyantardasha',
		q: 'Buscar',
		question: 'Tu pregunta',
		relocationLatitude: 'Latitud de reubicación',
		relocationLongitude: 'Longitud de reubicación',
		returnDate: 'Fecha de retorno',
		returnYear: 'Año de retorno',
		scheme: 'Esquema de karakas',
		seed: 'Semilla',
		sign: 'Signo zodiacal',
		significators: 'Incluir significadores KP',
		sookshma: 'Sookshma',
		soulUrge: 'Número del alma',
		spreadName: 'Nombre de la tirada',
		startDate: 'Fecha de inicio',
		startDatetime: 'Fecha y hora de inicio',
		strictOrbs: 'Usar orbes más estrictos',
		suit: 'Palo',
		system: 'Sistema de avastha',
		targetDate: 'Fecha objetivo',
		targetMonth: 'Mes objetivo',
		time: 'Hora',
		timezone: 'Zona horaria',
		top: 'Mejores eventos por ventana',
		transitDate: 'Fecha de tránsito',
		transitTime: 'Hora de tránsito',
		type: 'Tipo de patrón',
		vedic: 'Védica',
		western: 'Occidental',
		year: 'Año',
		zodiac: 'Signo zodiacal',
	},
	enums: {
		'arcana.major': 'Arcano Mayor',
		'arcana.minor': 'Arcano Menor',
		'ayanamsa.custom': 'Personalizado',
		'ayanamsa.kp-newcomb': 'KP Newcomb',
		'ayanamsa.kp-old': 'KP Old',
		'ayanamsa.lahiri': 'Lahiri',
		'ayanamsa.raman': 'B.V. Raman',
		'chakra.Crown': 'Corona',
		'chakra.Heart': 'Corazón',
		'chakra.Root': 'Raíz',
		'chakra.Sacral': 'Sacro',
		'chakra.Solar Plexus': 'Plexo Solar',
		'chakra.Third Eye': 'Tercer Ojo',
		'chakra.Throat': 'Garganta',
		'context.address': 'Dirección',
		'context.clock': 'Reloj',
		'context.license-plate': 'Matrícula',
		'context.phone': 'Teléfono',
		'context.price': 'Precio',
		'context.receipt': 'Recibo',
		'coordinateSystem.sidereal': 'Sideral',
		'coordinateSystem.tropical': 'Tropical',
		'element.Air': 'Aire',
		'element.Earth': 'Tierra',
		'element.Fire': 'Fuego',
		'element.Storm': 'Tormenta',
		'element.Water': 'Agua',
		'family.akriti': 'Akriti',
		'family.asraya': 'Asraya',
		'family.classical': 'Clásica',
		'family.dala': 'Dala',
		'family.sankhya': 'Sankhya',
		'focus.finance': 'Finanzas',
		'focus.general': 'General',
		'houseSystem.equal': 'Casas iguales',
		'houseSystem.koch': 'Koch',
		'houseSystem.placidus': 'Placidus',
		'houseSystem.whole-sign': 'Signo entero',
		'lang.de': 'Alemán',
		'lang.en': 'Inglés',
		'lang.es': 'Español',
		'lang.fr': 'Francés',
		'lang.hi': 'Hindi',
		'lang.pt': 'Portugués',
		'lang.ru': 'Ruso',
		'lang.tr': 'Turco',
		'nodeType.mean': 'Nodo medio',
		'nodeType.true': 'Nodo verdadero',
		'planet.Jupiter': 'Júpiter',
		'planet.Mars': 'Marte',
		'planet.Mercury': 'Mercurio',
		'planet.Saturn': 'Saturno',
		'planet.Venus': 'Venus',
		'scheme.eight': 'Ocho karakas',
		'scheme.seven': 'Siete karakas',
		'suit.cups': 'Copas',
		'suit.pentacles': 'Pentáculos',
		'suit.swords': 'Espadas',
		'suit.wands': 'Bastos',
		'system.baladi': 'Baladi',
		'system.deeptadi': 'Deeptadi',
		'system.jagradadi': 'Jagradadi',
		'type.compound': 'Compuesto',
		'type.master': 'Maestro',
		'type.mirror': 'Espejo',
		'type.repeating': 'Repetido',
		'type.root': 'Raíz',
		'type.sequential': 'Secuencial',
		'zodiac.aquarius': 'Acuario',
		'zodiac.aries': 'Aries',
		'zodiac.cancer': 'Cáncer',
		'zodiac.capricorn': 'Capricornio',
		'zodiac.gemini': 'Géminis',
		'zodiac.leo': 'Leo',
		'zodiac.libra': 'Libra',
		'zodiac.pisces': 'Piscis',
		'zodiac.sagittarius': 'Sagitario',
		'zodiac.scorpio': 'Escorpio',
		'zodiac.taurus': 'Tauro',
		'zodiac.virgo': 'Virgo',
	},
});
